module.exports = __webpack_public_path__ + "img/84.4a40d7ad.jpg";